import {request} from "@/api/request";

const state = {
    nticketCategoryList: [],
}

const getters = {
    getNticketCategoryList: state => state.nticketCategoryList,
}

const mutations = {
    updateNticketCategoryList(state, obj) {
        state.nticketCategoryList = obj.data;
    },
}
const actions = {
    setNticketCategory({commit, rootState}, {}) {
        try {
            request.get('itemcategory' ,{ip:0,type:'pass'}).then(res => {
                if (res.data.Data.Result.Info.type != 1) {
                    return false;
                }
                let categoryList = res.data.Data.Result.List
                commit('updateNticketCategoryList', {data: categoryList})
            })
        } catch (e) {
            console.log(e);
        }
    },
}
export default {namespaced: true, state, getters, mutations, actions}
